import { isNotUndefined } from 'infrastructure/functions';

import {
  additionalFollowUpText,
  compareToLastReview,
  croOrDncText,
  reviewedReadings,
  needEscalateText,
  uniqueDaysText,
  waitingDeviceReplacement,
} from '../helpers';

import type { TMaBloodPressureYellowDataOptional } from '../../types';

export const bloodPressure = (data: TMaBloodPressureYellowDataOptional) => {
  let text = '';

  if (isNotUndefined(data.difficultiesWithBPOrPulse)) {
    text += `Patient ${
      data.difficultiesWithBPOrPulse ? 'reported' : 'did not report'
    } any difficulties with blood pressure or pulse readings since the last call. `;
  }

  if (data.difficultiesWithBPOrPulseComment?.trim())
    text += `${data.difficultiesWithBPOrPulseComment}. `;

  const waitingDeviceReplacementText = waitingDeviceReplacement(
    data.waitingForDeviceReplacement,
    data.waitingForDeviceReplacementList,
  );
  if (waitingDeviceReplacementText.trim())
    text += `\n${waitingDeviceReplacementText}`;
  if (data.waitingForDeviceReplacementComment?.trim()) {
    if (data.waitingForDeviceReplacement === undefined) text += '\n';
    text += `${data.waitingForDeviceReplacementComment}. `;
  }

  const maReviewedReadingsText = reviewedReadings({
    template: 'MA',
    type: 'NIBP',
    atRiskNumber: data.atRiskNumber,
    thresholds: [
      {
        name: 'systolic',
        lowValue: data.lowestSystolic,
        highValue: data.highestSystolic,
      },
      {
        name: 'diastolic',
        lowValue: data.lowestDiastolic,
        highValue: data.highestDiastolic,
      },
      {
        name: 'pulse',
        lowValue: data.lowestPulse,
        highValue: data.highestPulse,
      },
    ],
  });
  if (maReviewedReadingsText.trim()) text += `\n${maReviewedReadingsText}`;

  const highTrendsItems = data.highTrends?.join(', ') ?? [];
  if (data.typeofTrend === 'high' && highTrendsItems.length > 0) {
    text += '\n';
    text += `High trends noted for the following: ${highTrendsItems}. `;
  }
  const lowTrendItems = data.lowTrends?.join(', ') ?? [];
  if (data.typeofTrend === 'low' && lowTrendItems.length > 0) {
    text += '\n';
    text += `Low trends noted for the following: ${lowTrendItems}. `;
  }
  if (data.typeofTrend === 'none') {
    text += '\n';
    text += 'No significant trends noted. ';
  }

  const comparedToLastReviewText = compareToLastReview(
    data.comparedToLastReview,
    data.comparedToLastReviewTrend,
  );
  if (comparedToLastReviewText.trim()) text += `\n${comparedToLastReviewText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysText(data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
